import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@monorepo-channels/shared/util-environments'
import { Voucher } from '../../../control-panel.service'

@Injectable({
	providedIn: 'root',
})
export class ConciergeCancelVoucherService {
	private baseUrl = `${environment.channelsAPIURL}/api/v1`
	private http = inject(HttpClient)

	constructor() {}

	update(id: string, updatedVoucher: Partial<Voucher>): Observable<Voucher> {
		return this.http.patch<Voucher>(`${this.baseUrl}/vouchers/${id}`, updatedVoucher, {
			headers: {
				partnerId: '595166383625c506d4868f28',
			},
		})
	}
}
